// https://developer.mozilla.org/fr/docs/Web/API/Intersection_Observer_API

document.addEventListener("trainingSession:mounted", () => {
  const content = document.querySelector(".app-page__content");
  const title = document.querySelector("h1.app-page__title");
  const navbarTitle = document.getElementById("app-page-navbar-title");

  if (!content || !title || !navbarTitle) return;

  const observer = new IntersectionObserver(
    ([entry]) => {
      navbarTitle.classList.toggle("app-page__navbar-title--visible", !entry.isIntersecting);
    },
    { root: content, threshold: 0 }
  );

  observer.observe(title);
});
